import { Component, OnDestroy, OnInit, Renderer2, inject, output, signal } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { WordCloudService } from '@services/word-cloud/word-cloud.service';

@Component({
  selector: 'app-word-cloud-modal',
  templateUrl: './word-cloud-modal.component.html',
  styleUrls: ['./word-cloud-modal.component.scss'],
  standalone: true,
})
export class WordCloudModalComponent implements OnInit, OnDestroy {
  readonly #renderer = inject(Renderer2);
  readonly #wordCloudService = inject(WordCloudService);

  readonly closeFilter = output<void>();

  readonly title = signal<string>('');
  readonly imageUrl = signal<SafeUrl>('');

  ngOnInit() {
    this.getTitle();
    this.getImageUrl();
    this.#renderer.addClass(document.body, 'modal-open');
  }

  ngOnDestroy() {
    this.#renderer.removeClass(document.body, 'modal-open');
  }

  getTitle(): void {
    this.title.set(this.#wordCloudService.modalTitle);
  }

  getImageUrl(): void {
    this.imageUrl.set(this.#wordCloudService.modalImageUrl);
  }

  onClose() {
    this.closeFilter.emit();
  }
}
